import React from 'react'
import injectSheet from 'react-jss'
import {
  TitleContainer,
  AdminOfferListItem,
} from '../../'

const AdminOfferList = (props) => {
  const {
    classes,
    data,
  } = props

  return (
    <TitleContainer title="Angebote">
      <ul className={`${classes.list}`}>
        {data && data.loading && <p>Loading...</p>}
        {data && data.error && <p>Error :(</p>}
        {data && !data.loading && !data.error && data.offers.map(offer => (
          <li
            key={`${offer.id}`}
          >
            <AdminOfferListItem offer={offer} />
          </li>
        ))}
      </ul>
    </TitleContainer>
  )
}

const styles = theme => ({
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${theme.sizes.gutter / 2}px`,
  },
})


export default injectSheet(styles)(AdminOfferList)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminOfferList.jsx